import { apiInstance } from 'api/utils';
import { CustomerType } from 'store/modules/Customers/types';

export default {
  createCustomer: ({
    firstName,
    lastName,
    intelligentOfficeId
  }: {
    firstName: string;
    lastName?: string;
    intelligentOfficeId: string | null;
  }) => {
    return apiInstance.request({
      method: 'POST',
      url: '/customers/',
      data: {
        first_name: firstName,
        last_name: lastName,
        intelligent_office_id: intelligentOfficeId
      }
    });
  },
  createCustomers: (data: CustomerType[]) => {
    return apiInstance.request({
      method: 'POST',
      url: '/customers/create/',
      data
    });
  },
  editCustomer: ({
    id,
    first_name,
    last_name
  }: {
    id: number;
    first_name: string;
    last_name?: string;
  }) => {
    return apiInstance.request({
      method: 'PUT',
      url: `/customers/${id}/`,
      data: {
        first_name,
        last_name
      }
    });
  },
  assignCustomers: (customers: any, adviser_id: number) => {
    return apiInstance.request({
      method: 'POST',
      url: '/customers/assign/',
      data: {
        customers,
        adviser_id
      }
    });
  }
};
